import { jsxs, jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuRadioItem } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownItem, dropdownItemClickable, dropdownItemContent } from '../../shared/styles/item.vanilla.mjs';
import { DropdownSlot } from '../slot/Slot.mjs';

const DropdownRadioItem = forwardRef(
  ({
    children,
    className: classNameFromProps,
    leftSlot,
    onPointerUp,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      dropdownItem,
      !props.disabled && dropdownItemClickable,
      classNameFromProps
    );
    const handlePointerUp = composeEventHandlers(onPointerUp, (event) => {
      if (!event.isDefaultPrevented()) {
        event.preventDefault();
      }
    });
    return /* @__PURE__ */ jsxs(
      DropdownMenuRadioItem,
      {
        "data-scope": "dropdown",
        "data-part": "radio-item",
        className,
        onPointerUp: handlePointerUp,
        ref: forwardedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsx(DropdownSlot, { "data-scope": "dropdown", "data-part": "radio-item-left-slot", children: leftSlot }),
          /* @__PURE__ */ jsx(
            "div",
            {
              "data-scope": "dropdown",
              "data-part": "radio-item-content",
              className: dropdownItemContent,
              children
            }
          )
        ]
      }
    );
  }
);

export { DropdownRadioItem };
//# sourceMappingURL=RadioItem.mjs.map
